import type { FunnelAnswers } from "../config";
import { ELIGIBLE_LEAD_INTENTS } from "../types";

import type { IntakeOfficeAvailabilityConfig } from "./getIntakeOfficeAvailability";
import {
  familyConfig,
  getIntakeOfficeAvailability,
  immigrationConfig,
} from "./getIntakeOfficeAvailability";

export function getCmnEligibility(
  answers: Pick<FunnelAnswers, "practice" | "leadIntent">,
  isImmigrationCmnEnabled: boolean,
) {
  const isImmigration = answers.practice === "immigration";

  let config: IntakeOfficeAvailabilityConfig;
  let isEligible: boolean;

  if (isImmigration) {
    if (!isImmigrationCmnEnabled) {
      return {
        isEligible: false,
        isAvailable: false,
        availabilityRange: null,
      };
    }
    config = immigrationConfig;
    isEligible = true;
  } else {
    config = familyConfig;
    isEligible =
      answers.leadIntent !== undefined &&
      ELIGIBLE_LEAD_INTENTS.has(answers.leadIntent);
  }

  const intakeOfficeAvailability = getIntakeOfficeAvailability(config);
  isEligible &&= intakeOfficeAvailability.isAvailable;

  return {
    isEligible,
    isAvailable: intakeOfficeAvailability.isAvailable,
    availabilityRange: intakeOfficeAvailability.availabilityRange,
  };
}
